import { render, staticRenderFns } from "./ConfirmDeletionModal.vue?vue&type=template&id=1e5efae6&"
import script from "./ConfirmDeletionModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeletionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports